export var emptyGeneralState = { IsActivateGeneralCargoCareProfile: false, ProfileCode: '', ProfileDescription: '', InsertedBy: '', InsertedDTTM: null, StateCd: '', UpdatedBy: '', UpdatedDTTM: null };


export enum IECAL {
    TimeSinceTheLatestPowerOff = 1,
    TimeSpentOfPowerBeforeAssignmentWillBeExcluded = 2,
    AllTimeSpentOffPowerWillBeExcluded = 3
}

export var emptyPowerState = {
    IsActivatePowerCargoCareProfile: false, MaxOffPowerDuration: '', OffPowerAlertSeverity: '', IsRaiseOffPowerInsideGeofence: null,
    IsPowerRestoredAlert: null, SelectedGeofences: [], suggestionsGeofences: [], userAGGGeofencesData: [], UserAccessGeofenceList: [],
    GeofenceTagName: '', targetId: '', LoginGeofences: [], cargoCareSeverity: [], PowerRestoredAlertSeverity: '', CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true, OffPowerIncludeExcludeCalculation:IECAL.TimeSinceTheLatestPowerOff.toString()
};

export var emptyCargoCareWizardDefaultValues = {
    MaxOffPowerDuration: '',
    OffPowerAlertSeverity: '',

    AttemptsCycleWithin: '',
    Hours: '',
    ExcessiveDefrostAlertSeverity: '',

    BTASevere: '',
    BTAMinor: '',
    BTAInformational: '',
    BTASevereU: '',
    BTAMinorU: '',
    BTAInformationalU: '',
    TempSetpointSeverity: '',
    TempSetpointSeverityValue: '',
    
    SevereSupplyTemp: '',
    MinorSupplyTemp: '',
    InformatinalSupplyTemp: '',
    IsSuppressSupplyTemp: false,
    IsPreventSupression: false,
    SupressionDuration: '',
    PreventSupressionAttempts: '',
    PreventSupressionHours: '',

    SevereReturnTemp: '',
    MinorReturnTemp: '',
    InformatinalReturnTemp: '',
    SevereReturnTempUnit: '',
    IsSuppressReturnTemp: false,
    IsPreventSupressionReturn: false,
    SupressionDurationReturn: '',
    PreventSupressionAttemptsReturn: '',
    PreventSupressionHoursReturn: '',

    LateReportingInterval: '',
};

export var emptySetpointState = {
    isActivateTempSetpoints: false, isSevereAlert: false, isMinorAlert: false, isInformationalAlert: false, isTempSetpointChangedAlert: false,
    BTASevere: '', BTAMinor: '', BTAInformational: '', BTASevereU: '', BTAMinorU: '', BTAInformationalU: '', TempSetpointSeverity: '', BookingTempUnitsOptions: [],
    CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true, CHKInvalidReeferTempSetpointAsMismatch:true
};

export var emptySupplyTempState =  {
    IsActivateSupplySetpoints: false, IsSupplySevereAlert: false, IsSupplyMinorAlert: false, IsSupplyInformationalAlert: false,
    SevereSupplyTempUnit: '', MinorSupplyTempUnit: '', InfSupplyTempUnit: '', TemperatureUnits: [], InformatinalSupplyTemp: '', TempSetpointSeverity:'',
    SevereSupplyTemp: '', MinorSupplyTemp: '', InformationalSupplyTemp: '', SevereSupplyDeviceRepFreq: '', MinorSupplyDeviceRepFreq: '', InfSupplyDeviceRepFreq: '',
    IsSuppressSupplyTemp: true, IsPreventSupression: false, SupressionDuration: '', PreventSupressionAttempts: '', PreventSupressionHours: '', IsChange: true,
    CHKSuppressSupplyTempAlertsDuringColdTreatment: true, CHKAlertsNotSuppressedAndSupplyTempReadingIsInvalid: true,
    SevereSupplyMismatchDuration: '', MinorSupplyMismatchDuration: '', InfoSupplyMismatchDuration: '', SevereSupplyMismatchDurationUnit: '',
    MinorSupplyMismatchDurationUnit: '', InfoSupplyMismatchDurationUnit: '', MismatchDurationUnits: []
};

export var emptyReturnTempState = {
    IsActivateReturnSetpoints: false, IsReturnSevereAlert: false, IsReturnMinorAlert: false, IsReturnInformationalAlert: false,
    SevereReturnTempUnit: '', MinorReturnTempUnit: '', InfReturnTempUnit: '', TemperatureUnits: [], InformatinalReturnTemp: '', TempSetpointSeverity: '',
    SevereReturnTemp: '', MinorReturnTemp: '', InformationalReturnTemp: '', SevereReturnDeviceRepFreq: '', MinorReturnDeviceRepFreq: '', InfReturnDeviceRepFreq: '',
    IsSuppressReturnTemp: true, IsPreventSupression: false, SupressionDuration: '', PreventSupressionAttempts: '', PreventSupressionHours: '', IsChange: true,
    CHKSuppressReturnTempAlertsDuringColdTreatment: true, CHKAlertsNotSuppressedAndReturnTempReadingIsInvalid: true,
    SevereReturnMismatchDuration: '', MinorReturnMismatchDuration: '', InfoReturnMismatchDuration: '', SevereReturnMismatchDurationUnit: '',
    MinorReturnMismatchDurationUnit: '', InfoReturnMismatchDurationUnit: '', MismatchDurationUnits:[]
};

export var emptyDefrostState = {
    IsActivateDefrostCargoCareProfile: false, AttemptsCycleWithin: '', Hours: '', ExcessiveDefrostAlertSeverity: ''
    , CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true
};

export var emptyGeofenceState = {
    IsActivateGeofenceCargoCareProfile: false, CHKReeferEntersPOLGeofence: false, CHKReeferExitsPOLGeofence: false,
    CHKReeferEntersPODGeofence: false, CHKReeferExitsPODGeofence: false, DDLReeferEntersPOLGeofence: '', DDLReeferExitsPOLGeofence: '',
    DDLReeferEntersPODGeofence: '', DDLReeferExitsPODGeofence: '', CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true
};
export var emptyInitialGeofenceState = {
    IsActivateGeofenceCargoCareProfile: false, CHKReeferEntersPOLGeofence: false, CHKReeferExitsPOLGeofence: false,
    CHKReeferEntersPODGeofence: false, CHKReeferExitsPODGeofence: false, DDLReeferEntersPOLGeofence: '', DDLReeferExitsPOLGeofence: '',
    DDLReeferEntersPODGeofence: '', DDLReeferExitsPODGeofence: '', CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: false
};

export var emptyColdTreatmentState = {
    IsActivateColdTreatmentProfile: false,
    CHKSuppressColdTreatmentAlert: true,
    TXTPostDefrostAlertSuppressiondureation: '120',

    CHKRaiseColdTreatmentAlert: true,
    CHKIncludeUSDA4CargoProbe: false,

    CHKRaiseSevereUSDA: false,
    CHKRaiseMinorUSDA: false,
    CHKRaiseInformationalUSDA: false,

    DDLSGNRaiseSevereUSDA: '',
    DDLSGNRaiseMinorUSDA: '',
    DDLSGNRaiseInformationalUSDA: '',

    TXTRaiseSevereUSDA: '',
    TXTRaiseMinorUSDA: '',
    TXTRaiseInformationalUSDA: '',

    DDLRaiseSevereUSDAUnit: '',
    DDLRaiseMinorUSDAUnit: '',
    DDLRaiseInformationalUSDAUnit: '',

    CHKRaiseUSDAWhenReadingIsLessThan: false,
    DDLRaiseUSDAWhenReadingIsLessThan: '',
    DDLSGNRaiseUSDAWhenReadingIsLessThan: '',
    TXTRaiseUSDAWhenReadingIsLessThan: '',
    DDLRaiseUSDAUnitWhenReadingIsLessThan: '',
    IsChange: true,
    CHKWhenUSDAReadingIsInvalid: true
};

export var emptyControlledAtmosphereState = {
    IsActivateControlledAtmosphereCareProfile: false, CHKO2readinglessthanboookingO2: false, CHKO2readingGreaterthanboookingO2: false,
    CHKCO2readinglessthanboookingCO2: false, CHKCO2readingGreaterthanboookingCO2: false, DDLO2readinglessthanboookingO2: '',
    DDLO2readingGreaterthanboookingO2: '', DDLCO2readinglessthanboookingCO2: '', DDLCO2readingGreaterthanboookingCO2: '', CHKSuppressControlled: false,
    TXTSuppressControlled: '24', CCSeverityStateOptions: [], IsChange: true, CHKWhenControlledAtmosphereReadingIsInvalid:true
};

export var emptyDoorState = {
    IsActivateDoorCargoCareProfile: false, CHKReeferDoorIsOpened: false, CHKReeferDoorIsClosed: false,
    CHKDoorSensorBatteryVoltageIsLow: false, DDLReeferDoorIsOpened: '', DDLReeferDoorIsClosed: '',
    DDLDoorSensorBatteryVoltageIsLow: '', CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true
};


export var emptyReeferAlarmState = {
    IsActivateReeferAlarmCargoCareProfile: false, CHKRaiseSevere: false, CHKRaiseMinor: false, CHKRaiseInformational: false,
    DDLRaiseSevere: '', DDLRaiseMinor: '', DDLRaiseInformational: '', IsChange: true
};

export var emptyDeviceState = {
    IsActivateDeviceRule: false, IsActivateLateReport: false, LateReportingInterval: '',
    LateReportSeverity: '', LateReportSeverityValue: '', CCSeverityStateOptions: [], TempSetpointSeverityValue: '', IsChange: true
};

export const emptyCCSeverityStates = {
    CCSeverityCd: '', CCSeverityValue: ''
};

export const emptyTemperatureUnits = {
    TemperatureUnitCd: '', CCSeverityValue: ''
};

export enum Mode {
    Add,
    Edit,
    Delete,
    View,
    None,
    Clone
}

export enum AssetSearch {
    SaveSearch = "Save Search",
    AssetID = "Asset ID(s)",
    BookingNumber = "Active Booking Number(s)",
    CargoCareProfile = "CargoCare Profile(s)",
    GeofenceStatus = "Geofence Status",
    GeofenceID = "Geofence ID",
    AssetTypes = "Asset Types",
    InventoryState = "Inventory State",
    OEM = "OEM Type",
    Countries = "Country",
    ReportingInterval = "Reporting(min)",
    VesselID = "Vessel",
    Voyage = "Voyage",
    Call = "Call",
    POL = "POL", /*  Added POL and POD for RCNG - 5518 */
    POD = "POD"
}

//RCNG-1209
export enum CCTabs {
    General = "General",
    Power = "Power",
    Alarm = "Alarm",
    SetPoint = "SetPoint",
    SupplyTemp = "SupplyTemp",
    ReturnTemp = "ReturnTemp",
    Defrost = "Defrost",
    ColdTreatment = "ColdTreatment",
    ControlledAtmosphere = "ControlledAtmosphere",
    Geofence = "Geofence",
    Door = "Door",
    Device = "Device",
    NoTabFurther = "NoTabFurther"
}
